'use client';

import { Search } from 'lucide-react';

import { Input } from '@/slw/shared/ui/input';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchInput({ value, onChange, placeholder = 'Search for people...' }: SearchInputProps) {
  return (
    <div className='relative'>
      <Search className='absolute left-5 top-1/2 transform -translate-y-1/2 text-muted-foreground' size={16} />
      <Input
        type='text'
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className='pl-10 focus-visible:ring-0 focus:ring-0 focus:outline-none sm:h-12 h-11'
      />
    </div>
  );
}
